import React from 'react';
import '../Responsive.css'

const BorderedLinesCell = ({ text }) => {
  // If text is null or undefined, default it to an empty string
  const lines = (text || '').split('\n');
  return (
    <td>
      {lines.map((line, index) => (
        <div key={index} className="line">
          {line}
        </div>
      ))}
    </td>
  );
};

export default BorderedLinesCell;
